import dataUtils from '@/common/dataUtils';

export default {
  /**
   * Calculates the path given the path segments, which need to be resolved using the attribute name
   * @param baseFolder is the root folder array, whose children can have an attribute "children" with a recursive folder structure
   * @param path Array of path segments
   */
  resolvePath(baseFolder, path) {
    let p = '';
    let ind = 0;
    let folder = baseFolder;
    while (ind < path.length) {
      if (!folder.children) {
        return p;
      }
      let childInd = path[ind];
      if (childInd >= folder.children.length) {
        return p;
      }
      folder = folder.children[childInd];
      if (p !== '') p += '/';
      p += folder.name;
      ind++;
    }
    return p;
  },
  buildMinimizedFolderTrees(folders) {
    const foldersByIdMin = {};
    folders.forEach((f) => (foldersByIdMin[f.id] = { id: f.id, instance: f.instance, name: f.name, parentId: f.parentId }));
    const instanceTrees = {};
    // associate children
    Object.keys(foldersByIdMin).forEach((id) => {
      const f = foldersByIdMin[id];
      if (f.parentId === 0) {
        dataUtils.push(instanceTrees, '' + f.instance, f);
      } else {
        const parent = foldersByIdMin[f.parentId];
        if (parent) dataUtils.push(parent, 'children', f);
      }
    });
    return instanceTrees;
  },
};
